<template>
  <kbd
    :class="DS_KEYBOARD_SHORTCUT_CLASSES.Root"
    data-cy="ds-keyboard-shortcut"
  >
    {{ renderedText }}
  </kbd>
</template>

<script setup lang="ts">
import { DS_KEYBOARD_SHORTCUT_CLASSES } from "@/src/design_system/primitives/keyboard_shortcut/constants/classes";
import { DSKeyboardShortcutProps } from "@/src/design_system/primitives/keyboard_shortcut/types/props";
import { isMac } from "@/src/shared/utils/device";
import { computed } from "vue";

const props = defineProps<DSKeyboardShortcutProps>();
const renderedText = computed(() => (isMac() ? props.macText || props.text : props.text));
</script>
